export default "__VITE_ASSET__1HCqd5$3__"